
import { Component, Mixins, Emit } from "vue-property-decorator";
import Login from "@/mixins/Login";
import FormLoginShareholder from "@/components/form/FormLogin/FormLoginShareholder.vue";
import FormAlignmentLine from "@/components/form/FormAlignmentLine/FormAlignmentLine.vue";
import FormAlignmentMGHRWC from "@/components/form/FormAlignmentMGHRWC/FormAlignmentMGHRWC.vue";
import BlockLine from "@/components/form/BlockLine/BlockLine.vue";
import axios, { AxiosResponse, AxiosError } from "axios";
import { fetchBanners } from "@/services/userService";
import { setLoginShareholderSession } from "@/lib/functions";
import store from "@/store";
import VueRouter from "vue-router";

Component.registerHooks(["beforeRouteEnter"]);

// @ is an alias to /src
@Component({
  components: {
    FormLoginShareholder,
    FormAlignmentLine,
    FormAlignmentMGHRWC,
    BlockLine,
  },
})
export default class LoginShareholder extends Mixins(Login) {
  private banner: BannerData[] = [];
  private viewState = 0;
  private hasUnsavedChanges = true;

  private mounted() {
    fetchBanners({ cat: "login-page" }).then((res) => {
      this.banner = res;
    });
    store.commit("loaded", true);
  }

  private async beforeRouteLeave(to: any, from: any, next: any) {
    // if (store.getters["auth/token"]) {
    //   await setLoginShareholderSession();
    // }
    next();
  }
}
